/**
 * @generated SignedSource<<556e6e3c7a1800f46e0dafb900cf61f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PhoneChangeMutationInput = {
  clientMutationId?: string | null;
  newPhone: string;
};
export type CampaignInputPhoneFormUpdateMutation$variables = {
  input: PhoneChangeMutationInput;
};
export type CampaignInputPhoneFormUpdateMutation$data = {
  readonly phoneChange: {
    readonly __typename: "PhoneChangeError";
    readonly errorType: string;
    readonly message: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type CampaignInputPhoneFormUpdateMutation = {
  response: CampaignInputPhoneFormUpdateMutation$data;
  variables: CampaignInputPhoneFormUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "errorType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "PhoneChangeError",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CampaignInputPhoneFormUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "phoneChange",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CampaignInputPhoneFormUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "phoneChange",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "type": "Influencer",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f5d08ac74ac7c27e1aeba2733f367164",
    "id": null,
    "metadata": {},
    "name": "CampaignInputPhoneFormUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation CampaignInputPhoneFormUpdateMutation(\n  $input: PhoneChangeMutationInput!\n) {\n  phoneChange(input: $input) {\n    __typename\n    ... on PhoneChangeError {\n      errorType\n      message\n    }\n    ... on Influencer {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "26f4010bf618e4e19689f3541b507af5";

export default node;
